import React from "react";

const CategoryMedia = ({ item }) => {
  const customBadge = {
    berita_umum: "badge-primary",
    tech: "badge-success",
    capital_market: "badge-secondary",
    lifestyle: "badge-danger",
    startup: "badge-warning",
    ekonomi_dan_bisnis: "badge-info",
    investasi: "badge-dark",
  };

  const customStr = {
    berita_umum: "Berita Umum",
    tech: "Tech",
    capital_market: "Capital Market",
    lifestyle: "Lifestyle",
    startup: "Startup",
    ekonomi_dan_bisnis: "Ekonomi dan Bisnis",
    investasi: "Investasi",
  };

  return (
    <div className={`badge rounded-pill text-white ${customBadge[item]}`}>
      {customStr[item]}
    </div>
  );
};

export default CategoryMedia;
